
import React, { useState } from 'react';
import { Phone, Mail, MapPin, Globe, Send, Building2 } from 'lucide-react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ListOfAddresses from './ListOfAdresses'
import countryCodes from '../../../utils/COUNTRIESLIST'
import US from '../../../Assets/contactus/Liberty.png'
import India from '../../../Assets/contactus/Indian_gateway.png'
import Singapore from '../../../Assets/contactus/singapore.png'
import Indonesia from '../../../Assets/contactus/indonesia.png'
import Malaysia from '../../../Assets/contactus/malaysia.png'

const ContactForm = () => {
  const [activeTab, setActiveTab] = useState('indonesia');

  const locationImages = {
  'united-states': US,
  'india': India,
  'singapore': Singapore,
  'indonesia': Indonesia,
  'malaysia': Malaysia,
};

  // Form state and validation
  const [formData, setFormData] = useState({
    fullname: "",
    company: "",
    workEmail: "",
    countrycode: "",
    mobilenumber: "",
    about: "",
    agreement: false,
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);


const locations = {
  'indonesia': {
    title: 'Indonesia',
    addresses: [
      {
        type: 'Main Office',
        address: 'PT KCS Technologies Indonesia\nBSD Green Office Park 1, 6th Floor\nJl. BSD Green Office Park, BSD City,\nTangerang - 15345',
        mapUrl: 'https://maps.google.com/?q=BSD+Green+Office+Park+1+6th+Floor+Tangerang+15345'
      },
      {
        type: 'Branch Address',
        address: 'PT KCS Technologies Indonesia\nRuko Pondasi, Jl. Pondasi Raya Blok H No. 21, RT. 010, RW. 017,\nDesa/Kelurahan Kayu Putih, Kec. Pulo Gadung, East Jakarta\nAdministrative City, DKI Jakarta Province - 13210',
        mapUrl: 'https://maps.google.com/?q=Ruko+Pondasi+Jl+Pondasi+Raya+Blok+H+No+21+Kayu+Putih+Pulo+Gadung+Jakarta+13210'
      }
    ],
    email: 'info@ptkcs.com',
    phone: '+62 852 1808 4208',
  },
  'singapore': {
    title: 'Singapore',
    addresses: [
      {
        type: 'Office',
        address: 'Kapil Technologies Pte Ltd\n#13-01, 105 Cecil Street,\nThe Octagon - 069534',
        mapUrl: 'https://maps.google.com/?q=105+Cecil+Street+The+Octagon+Singapore+069534'
      }
    ],
    email: 'info@kcs-tech.com',
    phone: '+62 852 1808 4208',
  },
  'united-states': {
    title: 'United States',
    addresses: [
      {
        type: 'Office',
        address: 'KCS Technologies Inc\n1603 Capitol Ave. Suite #310,\nCheyenne, Wyoming - 82001',
        mapUrl: 'https://maps.google.com/?q=1603+Capitol+Ave+Suite+310+Cheyenne+Wyoming+82001'
      }
    ],
    email: 'info@kcs-tech.com',
    phone: '+62 852 1808 4208',
  },
  'india': {
    title: 'India',
    addresses: [
      {
        type: 'Office',
        address: 'Kapil Technologies Pvt Ltd\nKapil Kavuri Hub, Nanakramguda,\nGachibowli, Hyderabad\nTelangana - 500032',
        mapUrl: 'https://maps.google.com/?q=Kapil+Kavuri+Hub+Nanakramguda+Gachibowli+Hyderabad+500032'
      }
    ],
    email: 'info@kcs-tech.com',
    phone: '+62 852 1808 4208',
  },
  'malaysia': {
    title: 'Malaysia',
    addresses: [
      {
        type: 'Office',
        address: 'Relevant Business Solutions SDN. BHD.\nUnit A805, No.1, Lorong Ultra B,\nOff Jalan Utara, 46200 Petaling Jaya,\nSelangor - 528225',
        mapUrl: 'https://maps.google.com/?q=Unit+A805+No.1+Lorong+Ultra+B+Petaling+Jaya+Selangor+528225'
      }
    ],
    email: 'info@kcs-tech.com',
    phone: '+62 852 1808 4208',
  }
};

  const tabs = Object.keys(locations);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validate = () => {
    let formErrors = {};
    if (!formData.fullname.trim()) formErrors.fullname = "Full Name is required";
    if (!formData.company.trim()) formErrors.company = "Company Name is required";
    if (!formData.workEmail.trim()) {
      formErrors.workEmail = "Work Email is required";
    } else if (!validateEmail(formData.workEmail)) {
      formErrors.workEmail = "Please enter a valid email address";
    }
    if (!formData.countrycode) formErrors.countrycode = "Country Code is required";
    if (!formData.mobilenumber.trim()) {
      formErrors.mobilenumber = "Mobile Number is required";
    } else if (!/^\d+$/.test(formData.mobilenumber)) {
      formErrors.mobilenumber = "Mobile Number must contain only digits";
    }
    if (!formData.about.trim()) formErrors.about = "Please tell us how we can help you";
    if (!formData.agreement) formErrors.agreement = "You must accept the agreement";
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) {
      toast.error("Please fill in all required fields correctly.");
      return;
    }

    setIsSubmitting(true);

    // Show loading toast
    const loadingToastId = toast.loading("Submitting your query, please wait...");

    try {
      const response = await fetch("https://api.kapiltech.com/api/ptkcs/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData)
      });

      const result = await response.json();

      // Dismiss loading toast
      toast.dismiss(loadingToastId);

      if (response.ok && result.success) {
        toast.success("Your query was received. We will get back to you soon.");
        // Clear form fields
        setFormData({
          fullname: "",
          company: "",
          workEmail: "",
          countrycode: "",
          mobilenumber: "",
          about: "",
          agreement: false,
        });
      } else {
        toast.error(result.message || "An error occurred. Please try again later.");
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      // Dismiss loading toast
      toast.dismiss(loadingToastId);
      toast.error("An error occurred. Please try again later.");
    } finally {
      setIsSubmitting(false);
    }
  };

return (
  <div style={{ backgroundColor: "#ffffff" }} className="min-h-screen pt-2">
    {/* Header Section */}
    <header className="py-2 px-4 sm:px-4 lg:px-4">
      <div className="max-w-7xl mx-auto text-center">
        <h1
          className="text-3xl md:text-3xl font-semibold mb-2 text-left py-2 font-man"
          style={{ color: "#111827" }}
        >
          Contact Us
        </h1>
      

      <div className="relative overflow-hidden">
      <img
        src={locationImages[activeTab]}
        alt={`${locations[activeTab].title} Office`}
        className="w-full h-full object-cover lazy-loading"
      />
      <div
        className="
          location-name 
          absolute 
          top-2 right-2 
          sm:top-4 sm:right-4
          px-2 py-1 sm:px-4 sm:py-2 
          flex items-center gap-1 sm:gap-2
          max-w-[90%]
        "
        style={{
          backgroundColor: "rgba(22, 31, 61, 1)",
          color: "#ffffff",
          borderRadius: "6px",
          fontWeight: "bold",
        }}
        >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 18.163 25.947"
          className="w-4 h-4 sm:w-5 sm:h-5 shrink-0"
        >
          <path
            d="M16.582,3A9.075,9.075,0,0,0,7.5,12.082c0,6.811,9.082,16.866,9.082,16.866s9.082-10.055,9.082-16.866A9.075,9.075,0,0,0,16.582,3Zm0,12.325a3.243,3.243,0,1,1,3.243-3.243A3.245,3.245,0,0,1,16.582,15.325Z"
            transform="translate(-7.5 -3)"
            fill="#fff"
          />
        </svg>

        <span className="text-xs sm:text-sm truncate">
          {locations[activeTab].title}
        </span>
      </div>

     </div>
    </div>
  </header>

    {/* Locations Section */}
    <section className="py-4 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <h2
            className="text-3xl font-bold mb-6 font-man"
            style={{ color: "#111827" }}
          >
            Our Locations
          </h2>

          {/* Location Tabs */}
          <div className="flex flex-wrap justify-start gap-6 mb-6">
            {tabs.map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                style={{
                  background: 'none',
                  border: 'none',
                  padding: '0.25rem 0.5rem',
                  color: activeTab === tab ? '#5fb8f4ff' : '#161515ff',
                  cursor: 'pointer',
                  outline: 'none',
                }}
                className='text-xl font-bold font-man'
              >
                {locations[tab].title}
              </button>
            ))}
          </div>
        </div>

        {/* Contact Information */}
        <div className="grid grid-cols-1 lg:grid-cols-2">
          {/* Left Column */}
          <div className="space-y-8">
            <div>
              <h3
                className="text-xl font-extrabold font-man mb-4"
                style={{ color: "#5fb8f4ff" }}
              >
                Visit
              </h3>
              {/* <p
                className="whitespace-pre-line leading-relaxed text-lg font-bold font-dm"
                style={{ color: "#374151" }}
              >
                {locations[activeTab].address}
              </p>
              <a
                href={locations[activeTab].mapUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center mt-3 transition-colors duration-200 text-xl font-bold font-man"
                style={{ color: "#5fb8f4ff" }}
              >
                <MapPin className="w-5 h-5 mr-2" />
                Map it
              </a> */}
              {locations[activeTab].addresses?.map((addr, index) => (
                <div key={index} className="mb-6">
                  <h4
                    className="text-lg font-bold mb-2 underline"
                    style={{ color: "#111827" }}
                  >
                    {addr.type} <span>:-</span>
                  </h4>
                  <p
                    className="whitespace-pre-line leading-relaxed text-lg font-bold font-dm"
                    style={{ color: "#374151" }}
                  >
                    {addr.address}
                  </p>
                  <a
                    href={addr.mapUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center mt-3 transition-colors duration-200 text-xl font-bold font-man"
                    style={{ color: "#5fb8f4ff" }}
                  >
                    <MapPin className="w-5 h-5 mr-2" />
                    Map it
                  </a>
                </div>
              ))}
            </div>

            <div>
              <div className='py-4'>
                <h3 className="text-xl font-extrabold font-man" style={{ color: "#5fb8f4ff" }}>
                  Email
                </h3>
                <p style={{ color: "#374151" }} className='text-lg font-bold font-dm'>{locations[activeTab].email}</p>
              </div>
              <div>
                <h3
                className="text-xl font-extrabold font-man"
                style={{ color: "#5fb8f4ff" }}
              >
                Phone
              </h3>
              <p style={{ color: "#374151" }} className='text-lg font-bold font-dm'>{locations[activeTab].phone}</p>
              </div>
            </div>
          </div>

          {/* Right Column - Contact Form */}
          <div>
            <h3
              className="text-xl font-semibold mb-6"
              style={{ color: "#111827" }}
            >
              Talk to us
            </h3>

            <form onSubmit={handleSubmit}>
              {/* Full Name & Company */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label
                    className="block text-sm  mb-3"
                    style={{ color: "#374151" }}
                  >
                    Full Name *
                  </label>
                  <input
                    type="text"
                    name="fullname"
                    value={formData.fullname}
                    onChange={handleChange}
                    className="w-full px-5 py-2 text-sm transition-all duration-300 focus:outline-none"
                    style={{
                      backgroundColor: errors.fullname ? "#FEF2F2" : "#f5f7fa",
                      border: `2px solid ${errors.fullname ? "#EF4444" : "#d1d5db"}`,
                      borderRadius: "0 0 0 0", 
                      fontSize: "14px",
                    }}
                  />
                  {errors.fullname && (
                    <p
                      className="text-xs mt-2 flex items-center gap-1"
                      style={{ color: "#dc2626" }}
                    >
                      <span
                        className="w-1 h-1 rounded-full"
                        style={{ backgroundColor: "#dc2626" }}
                      ></span>
                      {errors.fullname}
                    </p>
                  )}
                </div>

                <div>
                  <label
                    className="block text-sm mb-3"
                    style={{ color: "#374151" }}
                  >
                    Company Name *
                  </label>
                  <input
                    type="text"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                    className="w-full px-5 py-2 text-sm transition-all duration-300 focus:outline-none"
                    style={{
                      backgroundColor: errors.company ? "#FEF2F2" : "#f5f7fa",
                      border: `2px solid ${errors.company ? "#EF4444" : "#d1d5db"}`,
                      borderRadius: "0 0 0 0",
                      fontSize: "14px",
                    }}
                  />
                  {errors.company && (
                    <p
                      className="text-xs mt-2 flex items-center gap-1"
                      style={{ color: "#dc2626" }}
                    >
                      <span
                        className="w-1 h-1 rounded-full"
                        style={{ backgroundColor: "#dc2626" }}
                      ></span>
                      {errors.company}
                    </p>
                  )}
                </div>
              </div>

              {/* Work Email */}
              <div className="mb-6">
                <label
                  className="block text-sm mb-3"
                  style={{ color: "#374151" }}
                >
                  Work Email *
                </label>
                <input
                  type="email"
                  name="workEmail"
                  value={formData.workEmail}
                  onChange={handleChange}
                  className="w-full px-5 py-2 text-sm transition-all duration-300 focus:outline-none"
                  style={{
                    backgroundColor: errors.workEmail ? "#FEF2F2" : "#f5f7fa",
                    border: `2px solid ${errors.workEmail ? "#EF4444" : "#d1d5db"}`,
                    borderRadius: "0 0 0 0", 
                    fontSize: "14px",
                  }}
                />
                {errors.workEmail && (
                  <p
                    className="text-xs mt-2 flex items-center gap-1"
                    style={{ color: "#dc2626" }}
                  >
                    <span
                      className="w-1 h-1 rounded-full"
                      style={{ backgroundColor: "#dc2626" }}
                    ></span>
                    {errors.workEmail}
                  </p>
                )}
              </div>

              {/* Phone Number */}
              <div className="mb-6">
                <label
                  className="block text-sm  mb-3"
                  style={{ color: "#374151" }}
                >
                  Phone Number *
                </label>
                <div className="flex gap-3">
                  <select
                    name="countrycode"
                    value={formData.countrycode}
                    onChange={handleChange}
                    className="px-4 py-3 text-sm cursor-pointer transition-all duration-300 focus:outline-none"
                    style={{
                      backgroundColor: errors.countrycode ? "#FEF2F2" : "#f5f7fa",
                      border: `2px solid ${errors.countrycode ? "#EF4444" : "#d1d5db"}`,
                      borderRadius: "0 0 0 0", 
                      fontSize: "14px",
                    }}
                  >
                    <option value="">Code</option>
                    {countryCodes.map((country) => (
                      <option key={country.code} value={country.dialCode}>
                        {country.dialCode} ({country.name})
                      </option>
                    ))}
                  </select>
                  <input
                    type="tel"
                    name="mobilenumber"
                    value={formData.mobilenumber}
                    onChange={handleChange}
                    className="flex-1 px-5 py-2 text-sm transition-all duration-300 focus:outline-none"
                    style={{
                      backgroundColor: errors.mobilenumber ? "#FEF2F2" : "#f5f7fa",
                      border: `2px solid ${errors.mobilenumber ? "#EF4444" : "#d1d5db"}`,
                      borderRadius: "0 0 0 0", 
                      fontSize: "14px",
                    }}
                  />
                </div>
                {errors.countrycode && (
                  <p
                    className="text-xs mt-2 flex items-center gap-1"
                    style={{ color: "#dc2626" }}
                  >
                    <span
                      className="w-1 h-1 rounded-full"
                      style={{ backgroundColor: "#dc2626" }}
                    ></span>
                    {errors.countrycode}
                  </p>
                )}
                {errors.mobilenumber && (
                  <p
                    className="text-xs mt-2 flex items-center gap-1"
                    style={{ color: "#dc2626" }}
                  >
                    <span
                      className="w-1 h-1 rounded-full"
                      style={{ backgroundColor: "#dc2626" }}
                    ></span>
                    {errors.mobilenumber}
                  </p>
                )}
              </div>

              {/* Message */}
              <div className="mb-6">
                <label
                  className="block text-sm  mb-3"
                  style={{ color: "#374151" }}
                >
                  How can we help you? *
                </label>
                <textarea
                  name="about"
                  value={formData.about}
                  onChange={handleChange}
                  rows={5}
                  className="w-full px-5 py-4 text-sm resize-y transition-all duration-300 focus:outline-none"
                  style={{
                    backgroundColor: errors.about ? "#FEF2F2" : "#f5f7fa",
                    border: `2px solid ${errors.about ? "#EF4444" : "#d1d5db"}`,
                    borderRadius: "8px 0 0 8px", // Cut corner right-top, left-bottom
                    fontSize: "14px",
                  }}
                />
                {errors.about && (
                  <p
                    className="text-xs mt-2 flex items-center gap-1"
                    style={{ color: "#dc2626" }}
                  >
                    <span
                      className="w-1 h-1 rounded-full"
                      style={{ backgroundColor: "#dc2626" }}
                    ></span>
                    {errors.about}
                  </p>
                )}
              </div>

              {/* Agreement */}
              <div className="flex items-start gap-3 mb-6">
                <input
                  type="checkbox"
                  name="agreement"
                  checked={formData.agreement}
                  onChange={handleChange}
                  className="mt-1 w-5 h-5 border-2 rounded focus:ring-2"
                  style={{
                    borderColor: "#D1D5DB",
                    accentColor: "#2563EB",
                  }}
                />
                <label
                  className="text-sm leading-6"
                  style={{ color: "#64748b" }}
                >
                  I agree to the terms and conditions and privacy policy. *
                </label>
              </div>
              {errors.agreement && (
                <p
                  className="text-xs mb-4 flex items-center gap-1"
                  style={{ color: "#dc2626" }}
                >
                  <span
                    className="w-1 h-1 rounded-full"
                    style={{ backgroundColor: "#dc2626" }}
                  ></span>
                  {errors.agreement}
                </p>
              )}

              {/* Submit Button */}
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full py-4 px-8 text-base font-semibold transition-all duration-300 flex items-center justify-center gap-3 shadow-lg"
                style={{
                  color: "#ffffff",
                  backgroundColor: isSubmitting ? "#9CA3AF" : "#f57c00",
                  borderRadius: "6px",
                  cursor: isSubmitting ? "not-allowed" : "pointer",
                  fontSize: "16px",
                }}
              >
                {isSubmitting ? (
                  <>
                    <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                    Sending...
                  </>
                ) : (
                  <>Send Message</>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>

    {/* <section className='py-12'>
      <ListOfAddresses />
    </section> */}
    
    <ToastContainer />
  </div>
);

};

export default ContactForm;